import Axios from "axios";
import * as React from "react";
import { useCallback, useEffect, useState} from "react";
import { Button, Card } from "react-bootstrap";
import {CopyToClipboard} from "react-copy-to-clipboard";
import {FaClipboard} from "react-icons/fa";
import {HiOutlineClipboardCheck} from "react-icons/hi";
import { useHotKey } from "../Hooks";

export const RandomPwd: React.FunctionComponent = ():JSX.Element =>{
    const [pwdText, setPwdText] = useState("");
    const [isCopied, setIsCopied] = useState<boolean>(false);
    const hotKeySet = new Set<string>();
    hotKeySet.add("AltLeft");
    hotKeySet.add("KeyG");
    useHotKey(hotKeySet, ()=>{
        onGenerate();
    })

    const onGenerate = useCallback((e?: React.MouseEvent<HTMLElement, MouseEvent>)=>{
        if(e){
            e.preventDefault();
        }
        getRandomPwd();
        setIsCopied(false);
    },[setIsCopied]);

    const getRandomPwd = async ()=>{
        try{

            const response = await Axios.get(
                `${process.env.REACT_APP_API_URL}/api/v1/randomPassword`
            );
            setPwdText(response.data as string);
        } catch(error){
        }
    }
    

    useEffect(() =>{
        getRandomPwd();
    },[]);

    return (<>
        <Card>
            <Card.Header>
                    <button
                        className="btn btn-primary"
                        onClick={(e) => {
                            onGenerate(e);
                        }}
                    >
                        <u>G</u>enerate
                    </button>
                    <span className="card-header-text">{pwdText}</span>
                    <CopyToClipboard text={pwdText}
                        onCopy={() => setIsCopied(true)}>
                        <Button className="clip-button" variant="light">
                            {isCopied ? <HiOutlineClipboardCheck/> : <FaClipboard/>  }
                            
                        </Button>
                    </CopyToClipboard>
            </Card.Header>
        </Card>
    </>);
}
